import React, { useState } from "react"
import { useEffect } from "react";
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { contractDelete, doOutsourcingSign, patchOutsourcingContract, outsourcingContractDetail, outsourcingContractDelete, getAllCompanyList } from 'crud/auth.crud';

import { Link, useLocation, useHistory } from "react-router-dom"
import Util from "pages/Dashboard/Common/Util";

import Default from "../../assets/images/default.png"
import FileUploads from "../../components/RopikCustom/FileUploads";

import { useSelector } from "react-redux";

import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import SelectBox from "components/RopikCustom/SelectBox";

const OutsourcingContractManagementDetailScreen = () => {
  const selector = useSelector(state => state)

  const location = useLocation()
  const history = useHistory()
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group;

  const [id, setId] = useState(location.state.id);
  const [myCompany, setMyCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [data, setData] = useState({});
  const [inputItem, setInputItem] = useState({
    emitterList: []
  })
  const [deleteOn, setDeleteOn] = useState(false);
  const [contractCompanyGroupId, setContractCompanyGroupId] = useState('')
  const [companyFromSign, setCompanyFromSign] = useState(undefined)
  const [companyToSign, setCompanyToSign] = useState(undefined)
  const [edit, setEdit] = useState(false)
  const [previewImages, setPreviewImages] = useState([])
  const [contractList, setContractList] = useState([])
  const [imgArr, setImgArr] = useState([])
  const [emitterList, setEmitterList] = useState([])
  const [collectionCompanyList, setCollectionCompanyList] = useState([]);
  const [emitterCompanyList, setEmitterCompanyList] = useState([]);
  const [emitterCompanyNameList, setEmitterCompanyNameList] = useState([]);
  const [signFile, setSignFile] = useState({})
  const [isLoading, setIsLoading] = useState(false);

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({ ...prev, [key]: value }))
  }

  const selectEmitterList = (key, value) => {
    setInputItem(prev => ({...prev, [key]: prev[key].includes(value) ? prev[key] : [...prev[key], value]}));
  };
  
  const deleteEmitter = (item) => {
    setInputItem(prev => ({...prev, ['emitterList']: prev['emitterList'].filter(v => v !== item)}))
  }

  const isValidated = () => {
    if (!inputItem.subject) {
      alert("제목을 입력해주세요")
      return false
    }
    if (!inputItem.companyFrom) {
      alert('지입주는 업체를 선택해주세요')
      return false
    }
    if (!inputItem.companyTo) {
      alert('지입받는 업체를 선택해주세요')
      return false
    }
    if (!inputItem.startDate || !inputItem.endDate) {
      alert('계약기간을 입력해주세요')
      return false
    }
    // if (imgArr.length === 0) {
    //   return alert('계약서를 등록해주세요')
    // }
    return true
  }

  const getData = async () => {
    const params = `?id=${id}`
    const response = await outsourcingContractDetail(params);

    if (response.data.result === 'success') {
      const content = response.data?.data[0]
      setCompanyFromSign(response.data?.company_from_sign[0])
      setCompanyToSign(response.data?.company_to_sign[0])
      setData(content)
      setInputItem({
        subject: content.subject,
        content: content.content,
        companyFrom: content.company_from?.id,
        companyFromName: content.company_from?.name,
        companyTo: content.company_to?.id,
        companyToName: content.company_to?.name,
        companyTo: content.company_to?.id,
        companyToName: content.company_to?.name,
        emitterList: response.data?.emitter_list.map(v => v.company?.id),
        emitterNameList: response.data?.emitter_list.map(v => v.company?.name),
        startDate: content.start_date?.substr(0, 10),
        endDate: content.end_date?.substr(0, 10)
      })
      let arr = [...response.data?.file]
      for(let i = 0; i < response.data?.file.length; i++){
        arr[i].path = Util.addHostUrl(arr[i].path)
      }
      setContractList(arr)
      if ((myCompany === content?.company_from?.id || myCompany === content?.company_to?.id) && content?.company_from_sign !== 'Y' && content?.company_to_sign !== 'Y' && content?.state === 'N') {
        setDeleteOn(true)
      }
    }
  }

  const getCollectionList = async (search) => {
    setIsLoading(true)
    const params = {
      search: search || '',
      type: 'collection'
    }
    const response = await getAllCompanyList(params)
    if (response?.data?.result === 'success') {
      const content = response?.data?.data?.sort((a, b) => (a.id === companyData.id ? -1 : b.id === companyData.id ? 1 : 0));
      setCollectionCompanyList(content)
    } else {
      setCollectionCompanyList([])
    }
    setIsLoading(false)
  }
  
  const getEmitterList = async (search) => {
    setIsLoading(true)
    const params = {
      search: search || '',
      type: 'emitter',
    }
    const response = await getAllCompanyList(params)
    if (response?.data?.result === 'success') {
      const content = response?.data?.data
      setEmitterCompanyList(content)
      let companyNameList = []
      content.forEach(v => {
        companyNameList[v.id] = v.name
      })
      setEmitterCompanyNameList(companyNameList)
    } else {
      setEmitterCompanyList([])
      setEmitterCompanyNameList([])
    }
    setIsLoading(false)
  }

  const doDelete = async () => {
    if (!confirm("삭제하시겠습니까?")) {
      return;
    } else {
      await outsourcingContractDelete(id);
      alert("정상적으로 삭제되었습니다.");
      history.push("/outsourcing-contract-management-screen");
    }
  }

  const deleteImage = (index) => {
    let newImgArr = [...imgArr]
    newImgArr.splice(index, 1)
    setImgArr(newImgArr)
    handleFileChange(newImgArr)
  }

  const openContract = async (str) => {
    if (confirm("계약서에 서명하시겠습니까?")) {
      const param = {
        target: str,
        id: id,
        sign: 'Y',
      }
      const response = await doOutsourcingSign(param)
      if (response.data.result === 'success') {
        alert("정상적으로 서명하였습니다.");
        getData()
      } else {
        alert("서명에 실패하였습니다.");
      }
    }
  }

  const cancelContract = async (str) => {
    if (confirm("계약서 서명을 취소하시겠습니까?")) {
      const param = {
        target: str,
        id: id,
        sign: 'N',
      }
      const response = await doOutsourcingSign(param)
      if (response.data.result === 'success') {
        alert("정상적으로 서명 취소하였습니다.");
        getData()
      } else {
        alert("서명 취소에 실패하였습니다.");
      }
    }
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name : files[i].name,
        path :  URL.createObjectURL(files[i]),        
      }
      prevTmp.push(item)
    }
    let tmp = [...imgArr, ...event.target.files];
    tmp = tmp.filter((v, i) => {return i - 5 < 0})    
    setImgArr(tmp)    
    prevTmp = prevTmp.filter((v, i) => {return i - 5 < 0})
    setPreviewImages(prevTmp);
  };

  const editComplete = async () => {

    const params = {
      id : id,
      company_to: inputItem.companyTo,
      company_from: inputItem.companyFrom,
      start_date: inputItem.startDate,
      end_date: inputItem.endDate,
      subject: inputItem.subject,
      content: inputItem.content,
      state: 'N',
      status: 'Y',
      emitter_list: JSON.stringify(inputItem.emitterList)
    }

    const response = await patchOutsourcingContract(params)
    if(response.data.result === 'success'){
      alert('수정에 성공하였습니다.')
      getData()
      setEdit(false)
    } else {
      alert('수정에 실패하였습니다.')
    }
  }

  useEffect(() => {
    getData()
    getCollectionList()
    getEmitterList()
  }, [])
  
  useEffect(() => {
    if (inputItem.companyTo && inputItem.companyTo !== companyData.id) {
      changeInputCondition('companyFrom', companyData.id)
    }
  }, [inputItem.companyTo])

  useEffect(() => {
    if (inputItem.companyFrom && inputItem.companyFrom !== companyData.id) {
      changeInputCondition('companyTo', companyData.id)
    }
  }, [inputItem.companyFrom])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>지입 계약 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" breadcrumbItem="지입 계약서 관리" />

          <div className="d-flex align-items-center margin-bottom-12">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약상세</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약명</td>
                          <td colSpan="6" className="w-40">
                            {edit ?
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.subject} placeholder="계약명을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('subject', e.target.value)
                            }} />
                            :
                            <>{inputItem.subject}</>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">위탁업체명</td>
                          <td className="w-15">
                            {edit ?
                            <SelectBox
                              value={inputItem?.companyFrom}
                              onChange={changeInputCondition}
                              options={collectionCompanyList}
                              keyValue={'companyFrom'}
                            />
                            :
                            <>{inputItem.companyFrom}</>
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">수탁업체명</td>
                          <td className="w-15">
                            {edit ?
                            <SelectBox
                              value={inputItem?.companyTo}
                              onChange={changeInputCondition}
                              options={collectionCompanyList}
                              keyValue={'companyTo'}
                            />
                            :
                            <>{inputItem.companyTo}</>
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약기간</td>
                          <td className="w-40">
                            {edit ?
                            <>
                            {inputItem.startDate} ~ {inputItem.endDate}
                            </>
                            :
                            <>
                            <input className="waver-input-box w-40 border-radius-0 margin-right-4" type="date" value={inputItem.startDate} onChange={(e) => {
                              changeInputCondition('startDate', e.target.value);
                            }} />
                            <input className="waver-input-box w-40 border-radius-0" type="date" value={inputItem.endDate} onChange={(e) => {
                              changeInputCondition('endDate', e.target.value);
                            }} />
                            </>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">할당할 배출자</td>
                          <td className="w-15">
                            {edit ?
                            <SelectBox
                              value={''}
                              onChange={selectEmitterList}
                              options={emitterCompanyList}
                              keyValue={'emitterList'}
                            />
                            :
                            <>{''}</>
                            }
                          </td>
                          <td colSpan="4">
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                              {inputItem.emitterList.map((item, index) => {
                                return (
                                  <div key={'emitter_company_' + index} style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                    <p className="noMargin" style={{color: "white", lineHeight: '100%' }}>{emitterCompanyNameList[item]}</p>
                                    {edit &&
                                    <p className="noMargin" style={{color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                      deleteEmitter(item)
                                    }}>X</p>
                                    }
                                  </div>
                                )
                              })
                              }
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약내용</td>
                          <td colSpan="6" className="w-40">
                            {edit ?
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="내용을 입력해 주세요" value={inputItem.content}
                              onChange={(e) => {
                                changeInputCondition('content', e.target.value);
                              }} />
                            :
                            <>{inputItem.content}</>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">위탁업체 직인</td>
                          <td className="w-15">
                            {companyFromSign?.path &&
                            <img src={Util.addHostUrl(companyFromSign?.path)} />
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">수탁업체 직인</td>
                          <td className="w-15">
                            {companyToSign?.path &&
                            <img src={Util.addHostUrl(companyToSign?.path)} />
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text"></td>
                          <td className="w-40"></td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/outsourcing-contract-management-screen') }}>
              목록으로 이동
            </button>
            <div className="d-flex">
              {!edit && data?.state === 'N' &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                setEdit(true)
              }}>
                지입계약 수정
              </button>
              }
              {edit &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                if (isValidated()) {
                  editComplete()
                }
              }}>
                수정 완료
              </button>
              }
              {((inputItem.companyTo === myCompany && !companyToSign?.path) || (inputItem.companyFrom === myCompany && !companyFromSign?.path)) &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                openContract(inputItem.companyTo === myCompany ? 'company_to_sign' : 'company_from_sign')
              }}>
                지입계약 동의
              </button>
              }
              {((inputItem.companyTo === myCompany && companyToSign?.path) || (inputItem.companyFrom === myCompany && companyFromSign?.path)) &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 error-bg white-text button-border" onClick={() => {
                cancelContract(inputItem.companyTo === myCompany ? 'company_to_sign' : 'company_from_sign')
              }}>
                지입계약 동의 취소
              </button>
              }
            </div>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default OutsourcingContractManagementDetailScreen
